import { Typography } from '@mui/material';
import * as React from 'react';

export interface InfoPanelProps {
    children: JSX.Element[],
    heading?: string | null
}

export const InfoPanel = ({children, heading}: InfoPanelProps) => {
    return <>
        {(typeof heading !== "undefined") ? <Typography fontWeight={'fontWeightBold'} variant="h6">{heading}</Typography> : null}
        {children}
    </>;
}